// packages/shared-hooks/src/leads/useLeadIntakeHistory.ts
//
// `GET /leads/:id/intake-history` — the external call-center intake
// submissions tied to a Lead, newest first (#1260). The backend enforces
// row-level Lead visibility BEFORE returning, so reaching this data means
// the actor is cleared to read the Lead's PII. Mirrors `useLead`.
import { useQuery } from '@tanstack/react-query';
import {
  GetLeadIntakeHistoryResponseSchema,
  type GetLeadIntakeHistoryResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadsKeys } from './keys.js';

export function useLeadIntakeHistory(id: string | null) {
  const client = useApiClient();
  return useQuery<GetLeadIntakeHistoryResponse>({
    queryKey: leadsKeys.intakeHistory(id ?? ''),
    enabled: !!id,
    queryFn: ({ signal }) =>
      client.get<GetLeadIntakeHistoryResponse>(
        `/leads/${id}/intake-history`,
        { signal },
        GetLeadIntakeHistoryResponseSchema,
      ),
  });
}
